define([
	'internal_util/LocalizationUtil',
	'internal_util/UiUtil',
	'internal_util/Configuration',
	'amdi18n-loader?!view/nls/PrivacyPolicyView_strings',
	'lib/jquery'
], function (
	LocalizationUtil,
	UiUtil,
	Configuration,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * PrivacyPolicyView class
	 */
	return function () {
		var _view = (function () {
			var privacyPolicyDocumentURL = Configuration.get('PRIVACY_DOCUMENT_URL'),
				language = LocalizationUtil.getShortLocale().toLowerCase(),
				$privacyPolicyView = 
					jQuery(
						"<div id='skIdS_identity-privacy-container' class='skIdS_content-body'>" +
							Strings.privacy_text +
						"</div>");

			privacyPolicyDocumentURL = privacyPolicyDocumentURL.replace(/LANG/g, language);

			$privacyPolicyView.find('#skIdS_identity-privacy-download-image').attr('src', UiUtil.getImage('PDF_ICON').url());
			$privacyPolicyView.find('#skIdS_identity-privacy-button').attr('href', privacyPolicyDocumentURL);

			return $privacyPolicyView;
		})();


		// public methods

		this.get = function () {
			return _view;
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/PrivacyPolicyView.js
// module id = 354
// module chunks = 1